/*
 * Pique — Cart drawer urgency reservation timer
 * Session-based countdown ("Your items are reserved for mm:ss").
 *
 * - Defined once globally (loaded from layout/theme.liquid).
 * - Implemented as a custom element so it re-initialises automatically
 *   whenever the cart drawer is re-rendered via AJAX.
 * - The deadline is persisted in sessionStorage so the countdown keeps
 *   running across page loads within the same browsing session, instead of
 *   resetting to the full duration on every navigation.
 * - When the countdown reaches zero it restarts from the full duration so
 *   the cart always shows a live, urgent timer.
 */
(function () {
  if (customElements.get('reservation-timer')) return;

  class ReservationTimer extends HTMLElement {
    connectedCallback() {
      this.countEl = this.querySelector('[data-reservation-count]');
      this.minutes = parseInt(this.dataset.minutes, 10) || 10;
      this.durationMs = this.minutes * 60 * 1000;
      this.storageKey = 'btCartReservationDeadline';
      this.deadline = this._getDeadline();
      this._tick = this._tick.bind(this);
      this._tick();
      this.interval = setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    _getStore() {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    }

    _getDeadline() {
      var store = this._getStore();
      var now = Date.now();
      var dl = null;
      if (store) {
        var saved = parseInt(store.getItem(this.storageKey), 10);
        if (saved && saved > now) dl = saved;
      }
      if (!dl) {
        dl = now + this.durationMs;
        this._save(dl);
      }
      return dl;
    }

    _save(dl) {
      var store = this._getStore();
      if (store) {
        try {
          store.setItem(this.storageKey, String(dl));
        } catch (e) {}
      }
    }

    _reset() {
      this.deadline = Date.now() + this.durationMs;
      this._save(this.deadline);
    }

    _tick() {
      var remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        this._reset();
        remaining = this.deadline - Date.now();
      }
      var totalSec = Math.floor(remaining / 1000);
      var m = Math.floor(totalSec / 60);
      var s = totalSec % 60;
      var text = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (this.countEl) {
        this.countEl.textContent = text;
        this.countEl.setAttribute('datetime', 'PT' + m + 'M' + s + 'S');
      }
    }
  }

  customElements.define('reservation-timer', ReservationTimer);
})();
